import { useMemo, useState } from "react"
import NoSleep from "nosleep.js"
import { useEffectAsync } from "./useEffectAsync"

export default function useNoSleep() {
  const [enabled, setEnabled] = useState(false)
  const [isMounted, setIsMounted] = useState(false)

  const noSleep = useMemo(() => {
    if (!isMounted) {
      return null
    }

    return new NoSleep()
  }, [isMounted])

  useEffectAsync(async () => {
    setIsMounted(true)

    if (noSleep == null) {
      return
    }

    if (enabled) {
      document.addEventListener(
        "click",
        async function enableNoSleep() {
          document.removeEventListener("click", enableNoSleep, false)
          await noSleep.enable()
        },
        false,
      )
    } else {
      document.addEventListener(
        "click",
        async function disableNoSleep() {
          document.removeEventListener("click", disableNoSleep, false)
          await noSleep.disable()
        },
        false,
      )
    }
  }, [enabled, noSleep])

  return [enabled, setEnabled] as const
}
